import React from 'react'
import { Avatar, Col, Divider, Row } from 'antd'
import { BookOutlined, UserOutlined } from '@ant-design/icons'

import { BaseComponent } from 'src/components'
import { lib } from 'src/Utils'

class PopoverProfile extends BaseComponent {
  render() {
    const { activeActivity } = this.props

    return (
      <div onClick={e => {e.stopPropagation()}}>
        {activeActivity && (
          <div>
            <div style={{ padding: '6px 8px' }}>
              {lib.activity.getStatusComp(true, false)}
              <span style={{ color: '#888888', fontSize: '12px' }}>
                {activeActivity.task.name}
              </span>
            </div>
            <Divider style={{ margin: '0' }} />
          </div>
        )}
        <div>
          <Row style={{ padding: '8px 16px 12px 12px' }}>
            <Col>
              <Avatar
                size={64}
                icon={<UserOutlined />}
                src={this.props.user.photo}
                style={{ border: '1px solid #d5d5d5' }}
              />
            </Col>
            <Col style={{ marginLeft: '12px' }}>
              <div style={{ fontWeight: 500 }}>
                {lib.getFullName(this.props.user)}
              </div>
              {activeActivity && activeActivity.note && (
                <div style={{ color: '#46ad6b' }}>
                  <BookOutlined style={{ marginRight: '6px' }} />
                  {activeActivity.note.note}
                </div>
              )}
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default PopoverProfile